import { AvailableToInvestorType } from '../proto/tumelo/votingpolicy/v1/voting_policy';
const prefix = `votingPolicies/`;
export const IDToName = ({ votingPolicyID }) => {
    return prefix + votingPolicyID;
};
export const nameToID = (name) => {
    const parts = name.split('/');
    if (parts.length !== 2) {
        throw new Error(`bad voting policy name: ${name}`);
    }
    return {
        votingPolicyID: parts[1],
    };
};
export const AvailableToInvestorToDisplayString = (availableTo) => {
    switch (availableTo) {
        case AvailableToInvestorType.AVAILABLE_TO_INVESTOR_TYPE_INSTITUTIONAL:
            return 'Institutional';
        case AvailableToInvestorType.AVAILABLE_TO_INVESTOR_TYPE_RETAIL:
            return 'Retail EOW';
        case AvailableToInvestorType.AVAILABLE_TO_INVESTOR_TYPE_RETAIL_PTV:
            return 'Retail PTV';
    }
    return 'unknown';
};
